import * as React from "react";
import { Channel, PriceClient, SpotPrice } from "../api/ApiClient";
import { FetchStatus } from "../utils/FetchStatus";


interface State {
  prices: SpotPrice[],
  status: FetchStatus;
}
interface Props {
  elomrade: number
  channel: Channel
}


export default class PriceDetailsModal extends React.PureComponent<Props, State> {
  private priceClient: PriceClient = new PriceClient();

  readonly state: State = {
    prices: [],
    status: FetchStatus.IDLE,
  };
  
  componentDidMount() {
    this.fetchPrice();
  }


  render() {
    
    return (
      <div
        className="modal fade"
        id="priceDetailsModal"
        role="dialog"
        aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <p className="subheading">Våra prisdetaljer i ditt elområde -

              {(() => {
        switch (this.props.elomrade) {
          case 1:
            return ' SE1'
          case 2:
            return ' SE2'
          case 3:
            return ' SE3'
          case 4:
            return ' SE4'
          default:
            return null
        }
      })()}

              </p>
        
        {this.state.prices ?

        <table className="table">
          <thead>
          <tr>
              <td className="subheading">Prisdetalj</td>
              <td className="subheading">Pris öre/kWh</td>
            </tr>
          </thead>
          <tbody>
          
          <tr>
              <td>Spotpris</td>
              <td>
              {(() => {
                switch (this.props.elomrade) {
                  case 1:
                    return (this.state.prices[0]?.priceSE1 * 100).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2 })
                  case 2:
                    return (this.state.prices[0]?.priceSE2 * 100).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})
                  case 3:
                    return (this.state.prices[0]?.priceSE3 * 100).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})
                  case 4:
                    return (this.state.prices[0]?.priceSE4 * 100).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})
                  default:
                    return null
                }
              })()}
                </td>
            </tr>
          <tr>
              <td>Elcertifikat</td>
              <td>{(this.state.prices[0]?.priceCertificate * 100).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})}</td>
            </tr>
            <tr>
              <td>Urspungsgarantier</td>
              <td>{(this.state.prices[0]?.priceEnvironment * 100).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})}</td>
            </tr>
            <tr>
              <td>Profilkostnader</td>
              <td> {(() => {
                switch (this.props.elomrade) {
                  case 1:
                    return (this.state.prices[0]?.priceProfileCostSE1 * 100).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})
                  case 2:
                    return (this.state.prices[0]?.priceProfileCostSE2 * 100).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})
                  case 3:
                    return (this.state.prices[0]?.priceProfileCostSE3 * 100).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})
                  case 4:
                    return (this.state.prices[0]?.priceProfileCostSE4 * 100).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})
                  default:
                    return null
                }
              })()}</td>
            </tr>
            <tr>
              <td>Balanskostnader</td>
              <td>{(this.state.prices[0]?.priceBalanceCost * 100).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})}</td>
            </tr>
            <tr>
              <td>Elhandelskostnader</td>
              <td>{(this.state.prices[0]?.priceSupplierCost * 100).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})}</td>
            </tr>
            <tr>
              <td>Övriga administrativa kostnader</td>
              <td>{(this.state.prices[0]?.priceAdministrationCost * 100).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})}</td>
            </tr>
            <tr>

              <td>Total exkl moms</td>
              <td>
                {this.getTotalPriceExVat(this.props.elomrade).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})}
                </td>
            </tr>
            <tr>
              <td>Moms</td>
              <td>25%</td>
            </tr>
            <tr>
              <td className="subheading">Total inkl moms</td>
              <td className="subheading">{(this.getTotalPriceExVat(this.props.elomrade)*1.25).toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2})}</td>
            </tr>
          </tbody>
        </table>
        : null }
        <p className="subheading">
                Förklaring av spotpris och övriga prisdetaljer
              </p>
              <p className="copy">
              För dig med Rörligt avtal är spotpriset månads genomsnitt på elbörsen.
              För dig med timpris är spotpriset ditt viktade snitt över månaden baserat på din förbrukning.
              </p>
              <p className="copy"> Ovan är alltså en nedbrytning av våra prisdetaljer i öre/kWh som gäller från datum {this.state.prices[0]?.fromDate.format("L")}.<br></br>
              Vad ska vi säga... elbranschen är tråkig. Energimyndigheten har i EIFS 2024:2 beslutat att kunderna ska se de priskomponenter som elpriset består av. Kanske för att göra det mindre tråkigt med el, så håll till godo. Ovan är alltså de olika kostnader och avgifter som vi betalar för att köpa in elen som våra kunder förbrukar. Summerat så blir det också vad våra kunder betalar. Hoppas du blev precis så glad som beslutande organ tänkte att du skulle bli när du såg detta. Och har du någon fråga så är du välkommen att höra av dig till oss! </p>
                   
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal">
                Stäng
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  fetchPrice = async () => {
    console.debug("Fetching prices");
    this.setState({ status: FetchStatus.FETCHING });
    try {
      const prices = await this.priceClient.listLatest(0, this.props.channel);
      console.debug("Got prices", prices);
      this.setState({ prices, status: FetchStatus.DONE });
    } catch (error) {
      console.error("Failed to fetch prices", error);
      this.setState({ status: FetchStatus.ERROR });
    }
  };

  getTotalPriceExVat = (elomrade: number) => {
    switch (elomrade) {
      case 1:
        return (this.state.prices[0]?.priceSE1 * 100 +
          this.state.prices[0]?.priceCertificate * 100 +
          this.state.prices[0]?.priceEnvironment * 100 +
          this.state.prices[0]?.priceProfileCostSE1 * 100 +
          this.state.prices[0]?.priceBalanceCost * 100 + 
          this.state.prices[0]?.priceSupplierCost * 100 +
          this.state.prices[0]?.priceAdministrationCost * 100)
      case 2:
        return (this.state.prices[0]?.priceSE2 * 100 +
          this.state.prices[0]?.priceCertificate * 100 +
          this.state.prices[0]?.priceEnvironment * 100 +
          this.state.prices[0]?.priceProfileCostSE2 * 100 +
          this.state.prices[0]?.priceBalanceCost * 100 + 
          this.state.prices[0]?.priceSupplierCost * 100 +
          this.state.prices[0]?.priceAdministrationCost * 100)
      case 3:
        return (this.state.prices[0]?.priceSE3 * 100 +
          this.state.prices[0]?.priceCertificate * 100 +
          this.state.prices[0]?.priceEnvironment * 100 +
          this.state.prices[0]?.priceProfileCostSE3 * 100 +
          this.state.prices[0]?.priceBalanceCost * 100 + 
          this.state.prices[0]?.priceSupplierCost * 100 +
          this.state.prices[0]?.priceAdministrationCost * 100)
      case 4:
        return (this.state.prices[0]?.priceSE4 * 100 +
          this.state.prices[0]?.priceCertificate * 100 +
          this.state.prices[0]?.priceEnvironment * 100 +
          this.state.prices[0]?.priceProfileCostSE4 * 100 +
          this.state.prices[0]?.priceBalanceCost * 100 + 
          this.state.prices[0]?.priceSupplierCost * 100 +
          this.state.prices[0]?.priceAdministrationCost * 100)
      default:
        return 0
    }
    
  };

}
